module.exports = __webpack_public_path__ + "static/media/arbol.47229157.png";